import styles from "./PilotGrowthMobile.module.css"
import normalPromotionKo from "asset/image/pilot/normal-promotion-ko-mobile.png"
import normalPromotionEn from "asset/image/pilot/normal-promotion-en-mobile.png"
import rarePromotionKo from "asset/image/pilot/rare-promotion-ko-mobile.png"
import rarePromotionEn from "asset/image/pilot/rare-promotion-en-mobile.png"
import {useTranslation} from "react-i18next";

const PilotGrowthMobile = (props) => {

    const {t} = useTranslation();

    const {serverTime, revealTime, language} = props;

    if(serverTime.isBefore(revealTime)){
        return null;
    }

    return (
        <div className={styles["pilot-growth"]}>


            <div className={styles["tab-intro"]}>
                <div className={styles["tab-text"]}>
                    <div className={styles["tab-title"]}>
                        {
                            t("PILOT_GROWTH_SYSTEM")
                        }
                    </div>

                    <div className={styles["tab-desc"]}>
                        {
                            t("PILOT_GROWTH_SYSTEM_DESC")
                        }
                    </div>
                </div>
            </div>


            <section className={styles.normal}>

                <div className={styles.text}>
                    <div className={styles["normal-title"]}>
                        {
                            t("NORMAL_PILOT_PROMOTION")
                        }
                    </div>

                    <div className={styles.desc}>
                        {
                            t("NORMAL_PILOT_PROMOTION_DESC")
                        }
                    </div>
                </div>

                <div className={styles.container}>
                    {
                        language.includes("ko")  ?
                            <img src={normalPromotionKo} alt=""/>
                            : <img src={normalPromotionEn} alt=""/>
                    }
                </div>
            </section>


            <section className={styles.rare}>

                <div className={styles.text}>
                    <div className={styles["rare-title"]}>
                        {
                            t("RARE_PILOT_PROMOTION")
                        }
                    </div>

                    <div className={styles.desc}>
                        {
                            t("RARE_PILOT_PROMOTION_DESC")
                        }
                    </div>
                </div>

                <div className={styles.container}>
                    {
                        language.includes("ko")  ?
                            <img src={rarePromotionKo} alt=""/>
                            : <img src={rarePromotionEn} alt=""/>
                    }

                </div>


            </section>

        </div>
    )
}

export default PilotGrowthMobile;